import { Box, Link, Typography } from '@mui/material'
import React from 'react'
import LogoCadsoft from '../../assets/svg/logos/primary/cadsoft.svg'

const Copyright = (props) => {

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return (
    <Box sx={{alignItems: "center", backgroundColor: "#f9f9f9", display: "flex", flexDirection: "column", justifyContent: "center", p:1,}}>
      <Link href="https://www.cadsoft.com" target="_blank">
        <Box
          alt="Cadsoft Logo"
          component="img"
          loading="lazy"
          src={LogoCadsoft}
          sx={{border: "solid 1px transparent", height: 44.6166, p: .5, width: 150,
            "&:hover": {
              border: "solid 1px #000000",
            },
          }}
        />
      </Link>
      <Typography fontSize={12}>© Cadsoft Corporation {currentYear}, All Rights Reserved.</Typography>
    </Box>
  )
}

export default Copyright